import { useIsPredictionsProduct } from '@/hooks/use-is-predictions-product';

import { Bet } from './types';

// An open predictions order Polymarket has not matched yet. `is_matched` follows positions alone, so the result gate keeps a cancelled one from reading as unconfirmed.
export const useIsUnmatchedPrediction = (bet: Bet): boolean =>
    useIsPredictionsProduct() && bet.result === 'PENDING' && bet.is_matched === false;
